/* ═════════════════════════════════════════════════════════════════
   DEMO DATA
   Synthetic but realistic data shown everywhere when Demo Mode is on.
   Safe to publish — no real customer info. Generated once at module
   load from a seeded PRNG so the shape is deterministic across reloads.
   ═════════════════════════════════════════════════════════════════ */

// ── Seeded PRNG so demo data is stable across reloads ──
function mulberry32(seed) {
  return () => {
    let t = seed = (seed + 0x6D2B79F5) | 0;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
const rng = mulberry32(42);
const pick = (arr) => arr[Math.floor(rng() * arr.length)];
const pickN = (arr, n) => {
  const copy = [...arr];
  const out = [];
  for (let i = 0; i < n && copy.length > 0; i++) {
    const idx = Math.floor(rng() * copy.length);
    out.push(copy.splice(idx, 1)[0]);
  }
  return out;
};
const rand = (a, b) => a + rng() * (b - a);
const randInt = (a, b) => Math.floor(rand(a, b + 1));

// ── Catalog shared across orders + inventory + cuppings ──
const CATALOG = [
  { id: 101, name: "La Esperanza", variant: "12oz Whole Bean", price: 22, grams: 340, origin: "Huila, Colombia", process: "Washed" },
  { id: 101, name: "La Esperanza", variant: "5 lb Bulk", price: 78, grams: 2268, origin: "Huila, Colombia", process: "Washed" },
  { id: 102, name: "El Paraíso", variant: "12oz Whole Bean", price: 48, grams: 340, origin: "Cauca, Colombia", process: "Honey" },
  { id: 103, name: "PCF Decaf", variant: "12oz Whole Bean", price: 20, grams: 340, origin: "Nariño, Colombia", process: "EA Decaf" },
  { id: 103, name: "PCF Decaf", variant: "5 lb Bulk", price: 70, grams: 2268, origin: "Nariño, Colombia", process: "EA Decaf" },
  { id: 104, name: "Finca La Riviera", variant: "12oz Whole Bean", price: 28, grams: 340, origin: "Tolima, Colombia", process: "Natural" },
  { id: 105, name: "Elion Blend", variant: "12oz Whole Bean", price: 18, grams: 340, origin: "Huila / Tolima", process: "Washed/Natural" },
  { id: 105, name: "Elion Blend", variant: "5 lb Bulk", price: 62, grams: 2268, origin: "Huila / Tolima", process: "Washed/Natural" },
  { id: 105, name: "Elion Blend", variant: "12x 12oz Case", price: 198, grams: 4080, origin: "Huila / Tolima", process: "Washed/Natural" },
  { id: 106, name: "Ethiopia Guji", variant: "12oz Whole Bean", price: 26, grams: 340, origin: "Guji, Ethiopia", process: "Natural" },
  { id: 107, name: "Kenya Nyeri", variant: "12oz Whole Bean", price: 32, grams: 340, origin: "Nyeri, Kenya", process: "Washed" },
];

// ── Customer roster for the demo roastery ──
const CUSTOMERS = [
  { id: 2001, first: "Mika", last: "Nakamura", email: "mika@bluewavecafe.com", company: "Bluewave Café", addr: { a: "2340 Fillmore St", c: "San Francisco", p: "CA", z: "94115" }, tier: "wholesale" },
  { id: 2002, first: "Arturo", last: "Vasquez", email: "arturo@roastedsf.com", company: "Roasted SF", addr: { a: "518 Haight St", c: "San Francisco", p: "CA", z: "94117" }, tier: "wholesale" },
  { id: 2003, first: "Priya", last: "Srinivasan", email: "priya@corporatebrews.co", company: "Corporate Brews · Meta HQ", addr: { a: "1 Hacker Way", c: "Menlo Park", p: "CA", z: "94025" }, tier: "wholesale" },
  { id: 2004, first: "Diego", last: "Romero", email: "diego@twinpeaksroasting.com", company: "Twin Peaks Roasting", addr: { a: "1200 Market St", c: "Oakland", p: "CA", z: "94607" }, tier: "wholesale" },
  { id: 2005, first: "Sasha", last: "Lindqvist", email: "sasha@eastbaybeans.com", company: "East Bay Beans", addr: { a: "4000 Shattuck Ave", c: "Berkeley", p: "CA", z: "94703" }, tier: "wholesale" },
  { id: 2006, first: "Nathan", last: "O'Brien", email: "nathan@harborviewhotel.com", company: "Harborview Hotel Group", addr: { a: "55 Fourth St", c: "San Francisco", p: "CA", z: "94103" }, tier: "wholesale" },
  { id: 2007, first: "Camille", last: "Laurent", email: "camille@gourmetpantry.com", company: "Gourmet Pantry", addr: { a: "2100 Broadway", c: "Oakland", p: "CA", z: "94612" }, tier: "wholesale" },
  { id: 2008, first: "Yuki", last: "Tanaka", email: "yuki.tanaka@example.com", company: "", addr: { a: "1488 Page St", c: "San Francisco", p: "CA", z: "94117" }, tier: "d2c" },
  { id: 2009, first: "Michael", last: "Okonkwo", email: "m.okonkwo@example.com", company: "", addr: { a: "720 Alcatraz Ave", c: "Berkeley", p: "CA", z: "94710" }, tier: "d2c" },
  { id: 2010, first: "Rebecca", last: "Friedmann", email: "rebecca.f@example.com", company: "", addr: { a: "2821 Telegraph Ave", c: "Berkeley", p: "CA", z: "94705" }, tier: "d2c" },
  { id: 2011, first: "Samira", last: "Qureshi", email: "samira@example.com", company: "", addr: { a: "333 Grand Ave", c: "Oakland", p: "CA", z: "94610" }, tier: "d2c" },
  { id: 2012, first: "Tomás", last: "Alvear", email: "tomas.alvear@example.com", company: "", addr: { a: "1999 Mission St", c: "San Francisco", p: "CA", z: "94103" }, tier: "d2c" },
  { id: 2013, first: "Elise", last: "Bergstrom", email: "elise@fernwoodbistro.com", company: "Fernwood Bistro", addr: { a: "888 Piedmont Ave", c: "Oakland", p: "CA", z: "94611" }, tier: "wholesale" },
  { id: 2014, first: "Jonah", last: "Wellington", email: "jonah@example.com", company: "", addr: { a: "2400 Divisadero St", c: "San Francisco", p: "CA", z: "94115" }, tier: "d2c" },
  { id: 2015, first: "Anaya", last: "Krishnamurthy", email: "anaya@summitinnovation.io", company: "Summit Innovation", addr: { a: "550 California St", c: "San Francisco", p: "CA", z: "94104" }, tier: "wholesale" },
];

// ── Generate a pool of historical orders (used for analytics + clients) ──
// 2 years of history with 400x compounding growth (tiny at start, peak at end).
function generateHistory() {
  const orders = [];
  const now = Date.now();
  const MS_DAY = 86400000;
  const HISTORY_DAYS = 730;
  const startMs = now - HISTORY_DAYS * MS_DAY;

  // Peak cadence (orders-per-week at the very end of the window)
  const cadence = {
    wholesale: 1.4,
    d2c: 0.12,
  };

  CUSTOMERS.forEach(cust => {
    const perWeek = cadence[cust.tier] * (0.65 + rng() * 0.9);
    // Start near the beginning of the 2-year window
    let t = startMs + rng() * 30 * MS_DAY;
    while (t < now) {
      // 400x compounding growth: at t=start, orders are 400x less frequent; at t=now, full cadence
      const progress = Math.max(0, Math.min(1, (t - startMs) / (HISTORY_DAYS * MS_DAY)));
      // Floor at 0.02 so even year-1 customers place a few orders (gap ~250 days).
      // This ensures HISTORY has enough entries for DEMO_SHOPIFY_ORDERS.
      const growthFactor = Math.max(0.02, Math.pow(400, progress) / 400);
      // Divide base gap by growthFactor → early gaps are huge, late gaps are normal
      const baseGap = (7 / perWeek) * MS_DAY * (0.6 + rng() * 0.8);
      const gap = baseGap / growthFactor;
      t += gap;
      if (t > now) break;
      // Weekday/seasonality: most wholesale orders land Mon-Thu
      const date = new Date(t);
      const dow = date.getUTCDay();
      if (cust.tier === "wholesale" && (dow === 0 || dow === 6) && rng() < 0.7) continue;
      // Pick 1–3 line items, weighted toward whole-bean 12oz
      const itemCount = cust.tier === "wholesale" ? randInt(2, 5) : randInt(1, 2);
      const selected = pickN(CATALOG, itemCount);
      const line_items = selected.map(p => {
        const qty = cust.tier === "wholesale"
          ? (p.variant.includes("5 lb") ? randInt(2, 6) : p.variant.includes("12x") ? randInt(1, 3) : randInt(4, 14))
          : randInt(1, 2);
        return {
          id: Math.floor(rng() * 1e12),
          product_id: p.id,
          title: p.name,
          variant_title: p.variant,
          price: p.price.toFixed(2),
          quantity: qty,
          grams: p.grams * qty,
          sku: `PCF-${p.id}-${p.variant.slice(0, 4).toUpperCase()}`,
        };
      });
      const total = line_items.reduce((s, li) => s + parseFloat(li.price) * li.quantity, 0);
      orders.push({
        id: Math.floor(rng() * 1e13),
        order_number: 4800 + orders.length,
        created_at: new Date(t).toISOString(),
        cancelled_at: null,
        financial_status: "paid",
        fulfillment_status: "fulfilled",
        tags: "",
        total_price: total.toFixed(2),
        customer: {
          id: cust.id,
          first_name: cust.first,
          last_name: cust.last,
          email: cust.email,
          default_address: { company: cust.company },
        },
        email: cust.email,
        billing_address: {
          name: `${cust.first} ${cust.last}`,
          company: cust.company,
          address1: cust.addr.a,
          city: cust.addr.c,
          province: cust.addr.p === "CA" ? "California" : cust.addr.p,
          province_code: cust.addr.p,
          zip: cust.addr.z,
          country: "United States",
          country_code: "US",
        },
        shipping_address: {
          name: `${cust.first} ${cust.last}`,
          company: cust.company,
          address1: cust.addr.a,
          city: cust.addr.c,
          province: cust.addr.p === "CA" ? "California" : cust.addr.p,
          province_code: cust.addr.p,
          zip: cust.addr.z,
          country: "United States",
          country_code: "US",
          latitude: null,
          longitude: null,
        },
        line_items,
      });
    }
  });

  return orders.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
}

const HISTORY = generateHistory();

// Raw Shopify-shaped array fed into profitabilityOrders + clients.
export const DEMO_PROFITABILITY_ORDERS = HISTORY;

// Active Shopify orders (unfulfilled) — derived from the newest entries,
// reshaped into the compact "mapped" form the app uses for the Orders table.
export const DEMO_SHOPIFY_ORDERS = (() => {
  // Take the 80 most recent history entries and treat them as active.
  const recent = HISTORY.slice(0, 80);
  return recent.map(o => ({
    id: `#${o.order_number}`,
    shopifyId: o.id,
    customer: `${o.customer.first_name} ${o.customer.last_name}`,
    date: new Date(o.created_at).toLocaleDateString("en-US", { month: "short", day: "numeric" }),
    items: o.line_items.map(li => ({
      productId: li.product_id,
      name: li.title,
      variant: li.variant_title,
      sku: li.sku,
      qty: li.quantity,
      grams: li.grams,
    })),
    total: parseFloat(o.total_price),
    tagged: false,
    tags: "",
    // Channel mix for demo realism — most orders are online retail; we
    // sprinkle wholesale, EDI, and one-off transfers so the new
    // channel filter pills have content out of the box.
    channel: (() => {
      const r = (Number(o.id) || 0) % 10;
      if (r === 0 || r === 1) return "wholesale";
      if (r === 2) return "edi";
      if (r === 3) return "transfer";
      return "online";
    })(),
    financialStatus: "paid",
    fulfillmentStatus: "unfulfilled",
    shippingAddress: {
      address1: o.shipping_address.address1,
      city: o.shipping_address.city,
      province: o.shipping_address.province_code,
      province_code: o.shipping_address.province_code,
      zip: o.shipping_address.zip,
      latitude: null,
      longitude: null,
      name: o.shipping_address.name,
    },
  }));
})();

// Tag the first 53 orders for production — yields ~1,300 bags to pack.
for (let i = 0; i < Math.min(53, DEMO_SHOPIFY_ORDERS.length); i++) {
  DEMO_SHOPIFY_ORDERS[i].tagged = true;
  DEMO_SHOPIFY_ORDERS[i].tags = "production";
}

// ── Green inventory lots ──
const now = Date.now();
const MS_DAY = 86400000;
export const DEMO_LOTS = [
  {
    id: "lot_demo_01",
    name: "La Esperanza",
    sourceName: "Finca La Esperanza — Jorge Bermúdez",
    origin: "Huila, Colombia",
    process: "Washed",
    variety: "Caturra / Castillo",
    score: 87.5,
    lotCode: "COL-ESP-25A",
    supplier: "Cafe Imports",
    arrivalDate: new Date(now - 28 * MS_DAY).toISOString().slice(0, 10),
    ageDays: 28,
    initialWeightLbs: 440,
    currentWeightLbs: 312,
    bagSizeLbs: 154,
    moisture: 10.8,
    location: "Rack B-1",
    lowStockLbs: 60,
    pricePerLb: 4.25,
    events: [],
  },
  {
    id: "lot_demo_02",
    name: "El Paraíso",
    sourceName: "El Paraíso Microlot — Diego Samuel Bermúdez",
    origin: "Cauca, Colombia",
    process: "Honey",
    variety: "Pink Bourbon",
    score: 91.0,
    lotCode: "COL-PAR-24K",
    supplier: "Red Fox Coffee Merchants",
    arrivalDate: new Date(now - 62 * MS_DAY).toISOString().slice(0, 10),
    ageDays: 62,
    initialWeightLbs: 132,
    currentWeightLbs: 85,
    bagSizeLbs: 132,
    moisture: 11.1,
    location: "Rack A-2",
    lowStockLbs: 40,
    pricePerLb: 12.5,
    events: [],
  },
  {
    id: "lot_demo_03",
    name: "Ethiopia Guji",
    sourceName: "Hambela Natural — Testi Cooperative",
    origin: "Guji, Ethiopia",
    process: "Natural",
    variety: "Heirloom",
    score: 89.25,
    lotCode: "ETH-GJI-25B",
    supplier: "Osito Coffee",
    arrivalDate: new Date(now - 105 * MS_DAY).toISOString().slice(0, 10),
    ageDays: 105,
    initialWeightLbs: 330,
    currentWeightLbs: 186,
    bagSizeLbs: 110,
    moisture: 11.3,
    location: "Rack A-3",
    lowStockLbs: 50,
    pricePerLb: 6.8,
    events: [],
  },
  {
    id: "lot_demo_04",
    name: "PCF Decaf",
    sourceName: "COL-DCF-25C — EA Swiss Water",
    origin: "Nariño, Colombia",
    process: "EA Decaf",
    variety: "Castillo",
    score: null,
    lotCode: "COL-DCF-25C",
    supplier: "Cafe Imports",
    arrivalDate: new Date(now - 41 * MS_DAY).toISOString().slice(0, 10),
    ageDays: 41,
    initialWeightLbs: 275,
    currentWeightLbs: 150,
    bagSizeLbs: 154,
    moisture: 10.6,
    location: "Rack B-2",
    lowStockLbs: 40,
    pricePerLb: 5.8,
    events: [],
  },
  {
    id: "lot_demo_05",
    name: "Kenya Nyeri",
    sourceName: "Gakuyuini AA — Othaya Farmers Cooperative",
    origin: "Nyeri, Kenya",
    process: "Washed",
    variety: "SL-28 / SL-34",
    score: 90.0,
    lotCode: "KEN-NYI-25A",
    supplier: "Ally Coffee",
    arrivalDate: new Date(now - 6 * MS_DAY).toISOString().slice(0, 10),
    ageDays: 6,
    initialWeightLbs: 220,
    currentWeightLbs: 220,
    bagSizeLbs: 154,
    moisture: 10.4,
    location: "Rack A-1",
    lowStockLbs: 40,
    pricePerLb: 7.6,
    events: [],
  },
  {
    id: "lot_demo_06",
    name: "Finca La Riviera",
    sourceName: "La Riviera Natural — Carlos Imbachi",
    origin: "Tolima, Colombia",
    process: "Natural",
    variety: "Gesha",
    score: 88.75,
    lotCode: "COL-RIV-24H",
    supplier: "Cafe Imports",
    arrivalDate: new Date(now - 88 * MS_DAY).toISOString().slice(0, 10),
    ageDays: 88,
    initialWeightLbs: 400,
    currentWeightLbs: 48,
    bagSizeLbs: 154,
    moisture: 11.0,
    location: "Rack C-1",
    lowStockLbs: 60,
    pricePerLb: 6.4,
    events: [],
  },
  {
    id: "lot_demo_07",
    name: "Guatemala Antigua",
    sourceName: "Bella Vista — Luis Pedro Zelaya",
    origin: "Antigua, Guatemala",
    process: "Washed",
    variety: "Bourbon",
    score: 87.25,
    lotCode: "GTM-ANT-25A",
    supplier: "Royal Coffee",
    arrivalDate: new Date(now - 18 * MS_DAY).toISOString().slice(0, 10),
    ageDays: 18,
    initialWeightLbs: 308,
    currentWeightLbs: 248,
    bagSizeLbs: 154,
    moisture: 10.9,
    location: "Rack B-3",
    lowStockLbs: 60,
    pricePerLb: 5.4,
    events: [],
  },
  {
    id: "lot_demo_08",
    name: "Honduras Marcala",
    sourceName: "Finca La Maravilla — IHCAFE",
    origin: "Marcala, Honduras",
    process: "Washed",
    variety: "Catuai",
    score: 86.5,
    lotCode: "HND-MAR-25B",
    supplier: "Cafe Imports",
    arrivalDate: new Date(now - 12 * MS_DAY).toISOString().slice(0, 10),
    ageDays: 12,
    initialWeightLbs: 462,
    currentWeightLbs: 462,
    bagSizeLbs: 154,
    moisture: 10.7,
    location: "Silo 2",
    lowStockLbs: 80,
    pricePerLb: 4.5,
    events: [],
  },
  {
    id: "lot_demo_09",
    name: "Costa Rica Tarrazú",
    sourceName: "Finca Sumava — Don Mayid Llobet",
    origin: "Tarrazú, Costa Rica",
    process: "Honey",
    variety: "Caturra / Catuai",
    score: 88.0,
    lotCode: "CRI-TAR-24L",
    supplier: "Genuine Origin",
    arrivalDate: new Date(now - 142 * MS_DAY).toISOString().slice(0, 10),
    ageDays: 142,
    initialWeightLbs: 220,
    currentWeightLbs: 32,
    bagSizeLbs: 110,
    moisture: 11.4,
    location: "Rack C-2",
    lowStockLbs: 50,
    pricePerLb: 6.95,
    events: [],
  },
  {
    id: "lot_demo_10",
    name: "Brazil Cerrado",
    sourceName: "Fazenda Sertaozinho — Daniel Reis",
    origin: "Cerrado Mineiro, Brazil",
    process: "Natural",
    variety: "Mundo Novo / Catuai",
    score: 84.5,
    lotCode: "BRA-CER-25C",
    supplier: "Olam Specialty",
    arrivalDate: new Date(now - 35 * MS_DAY).toISOString().slice(0, 10),
    ageDays: 35,
    initialWeightLbs: 660,
    currentWeightLbs: 510,
    bagSizeLbs: 132,
    moisture: 10.6,
    location: "Silo 1",
    lowStockLbs: 100,
    pricePerLb: 3.85,
    events: [],
  },
  {
    id: "lot_demo_11",
    name: "Sumatra Lintong",
    sourceName: "Lintong Triple-Pick — Sidikalang",
    origin: "North Sumatra, Indonesia",
    process: "Wet-Hulled",
    variety: "Typica / Lini-S",
    score: 85.0,
    lotCode: "IDN-LNT-24M",
    supplier: "Royal Coffee",
    arrivalDate: new Date(now - 168 * MS_DAY).toISOString().slice(0, 10),
    ageDays: 168,
    initialWeightLbs: 286,
    currentWeightLbs: 71,
    bagSizeLbs: 143,
    moisture: 12.1,
    location: "Rack C-3",
    lowStockLbs: 50,
    pricePerLb: 5.6,
    events: [],
  },
  {
    id: "lot_demo_12",
    name: "Ethiopia Yirgacheffe",
    sourceName: "Worka Sakaro — Yirgacheffe Cooperative",
    origin: "Yirgacheffe, Ethiopia",
    process: "Washed",
    variety: "Heirloom (74158, 74110)",
    score: 89.5,
    lotCode: "ETH-YRG-25A",
    supplier: "Crop to Cup",
    arrivalDate: new Date(now - 9 * MS_DAY).toISOString().slice(0, 10),
    ageDays: 9,
    initialWeightLbs: 264,
    currentWeightLbs: 264,
    bagSizeLbs: 132,
    moisture: 10.5,
    location: "Rack A-4",
    lowStockLbs: 50,
    pricePerLb: 7.25,
    events: [],
  },
  {
    id: "lot_demo_13",
    name: "Kenya Kirinyaga",
    sourceName: "Kii AA — Rungeto Farmers Cooperative",
    origin: "Kirinyaga, Kenya",
    process: "Washed",
    variety: "SL-28 / Ruiru 11",
    score: 90.5,
    lotCode: "KEN-KIR-24N",
    supplier: "Genuine Origin",
    arrivalDate: new Date(now - 55 * MS_DAY).toISOString().slice(0, 10),
    ageDays: 55,
    initialWeightLbs: 154,
    currentWeightLbs: 38,
    bagSizeLbs: 154,
    moisture: 10.8,
    location: "Rack A-2",
    lowStockLbs: 40,
    pricePerLb: 8.5,
    events: [],
  },
  {
    id: "lot_demo_14",
    name: "Honduras Decaf",
    sourceName: "EA Sugar Cane — COMSA",
    origin: "Marcala, Honduras",
    process: "EA Decaf",
    variety: "Mixed",
    score: 84.0,
    lotCode: "HND-DCF-25A",
    supplier: "Olam Specialty",
    arrivalDate: new Date(now - 22 * MS_DAY).toISOString().slice(0, 10),
    ageDays: 22,
    initialWeightLbs: 220,
    currentWeightLbs: 196,
    bagSizeLbs: 110,
    moisture: 10.2,
    location: "Rack B-2",
    lowStockLbs: 40,
    pricePerLb: 5.95,
    events: [],
  },
  {
    // Sample-roast bench coffee — derived from a real Artisan .alog
    // file (#25, Apr 28 2026, 560g→452g, Kaleido 1.2 sample roaster).
    // Colombia Supremo is a screen-grade name rather than a microlot —
    // realistic demo data for the development bench.
    id: "lot_demo_15",
    name: "Colombia Supremo",
    sourceName: "Excelso 17/18 — multi-origin lot",
    origin: "Huila, Colombia",
    process: "Washed",
    variety: "Caturra / Castillo",
    score: 84.5,
    lotCode: "COL-SUP-25",
    supplier: "Cafe Imports",
    arrivalDate: new Date(now - 18 * MS_DAY).toISOString().slice(0, 10),
    ageDays: 18,
    initialWeightLbs: 154,
    currentWeightLbs: 142,
    bagSizeLbs: 154,
    moisture: 10.9,
    location: "Rack B-3",
    lowStockLbs: 40,
    pricePerLb: 4.05,
    events: [],
  },
];

/* Roasted SKUs — finished goods at the bag level. Each one consumes
   green from a referenced lot + a packaging bag SKU on every roast.
   onHandBags is the live "ready to ship" inventory; avgDailySales
   drives the days-of-supply calc on the Roasted stock dashboard. */
export const DEMO_ROASTED_SKUS = [
  { skuCode: "YIRG-12-WB",     name: "Ethiopia Yirgacheffe — 12oz",        coffeeName: "Ethiopia Yirgacheffe",   sourceLotId: "lot_demo_12", sizeLabel: "12 oz",  sizeOz: 12,   grind: "Whole bean", bagSku: "BAG-12-KFT",  retailPrice: 22.00, onHandBags: 78,  avgDailySales: 8.4, lastRoastAt: now -  3 * MS_DAY, status: "active" },
  { skuCode: "GUJI-12-WB",     name: "Ethiopia Guji Natural — 12oz",       coffeeName: "Ethiopia Guji",          sourceLotId: "lot_demo_03", sizeLabel: "12 oz",  sizeOz: 12,   grind: "Whole bean", bagSku: "BAG-12-BLK",  retailPrice: 24.00, onHandBags: 24,  avgDailySales: 5.6, lastRoastAt: now - 11 * MS_DAY, status: "active" },
  { skuCode: "KENYA-12-WB",    name: "Kenya Nyeri AA — 12oz",              coffeeName: "Kenya Nyeri",            sourceLotId: "lot_demo_05", sizeLabel: "12 oz",  sizeOz: 12,   grind: "Whole bean", bagSku: "BAG-12-KFT",  retailPrice: 26.00, onHandBags: 112, avgDailySales: 6.8, lastRoastAt: now -  1 * MS_DAY, status: "active" },
  { skuCode: "COL-ESP-12-WB",  name: "Colombia La Esperanza — 12oz",       coffeeName: "Colombia La Esperanza",  sourceLotId: "lot_demo_01", sizeLabel: "12 oz",  sizeOz: 12,   grind: "Whole bean", bagSku: "BAG-12-KFT",  retailPrice: 19.00, onHandBags: 145, avgDailySales: 11.2, lastRoastAt: now -  2 * MS_DAY, status: "active" },
  { skuCode: "COL-ESP-12-GR",  name: "Colombia La Esperanza — 12oz Ground", coffeeName: "Colombia La Esperanza", sourceLotId: "lot_demo_01", sizeLabel: "12 oz",  sizeOz: 12,   grind: "Ground",     bagSku: "BAG-12-KFT",  retailPrice: 19.00, onHandBags: 36,  avgDailySales: 4.1, lastRoastAt: now -  6 * MS_DAY, status: "active" },
  { skuCode: "COL-PAR-12-WB",  name: "Colombia El Paraíso Pink Bourbon",   coffeeName: "Colombia El Paraíso",    sourceLotId: "lot_demo_02", sizeLabel: "12 oz",  sizeOz: 12,   grind: "Whole bean", bagSku: "BAG-12-BLK",  retailPrice: 32.00, onHandBags: 18,  avgDailySales: 1.6, lastRoastAt: now -  9 * MS_DAY, status: "active" },
  { skuCode: "GTM-12-WB",      name: "Guatemala Antigua — 12oz",            coffeeName: "Guatemala Antigua",      sourceLotId: "lot_demo_07", sizeLabel: "12 oz",  sizeOz: 12,   grind: "Whole bean", bagSku: "BAG-12-KFT",  retailPrice: 21.00, onHandBags: 84,  avgDailySales: 5.0, lastRoastAt: now -  4 * MS_DAY, status: "active" },
  { skuCode: "HND-12-WB",      name: "Honduras Marcala — 12oz",             coffeeName: "Honduras Marcala",       sourceLotId: "lot_demo_08", sizeLabel: "12 oz",  sizeOz: 12,   grind: "Whole bean", bagSku: "BAG-12-KFT",  retailPrice: 18.00, onHandBags: 132, avgDailySales: 7.2, lastRoastAt: now -  2 * MS_DAY, status: "active" },
  { skuCode: "BRA-12-WB",      name: "Brazil Cerrado — 12oz",               coffeeName: "Brazil Cerrado",         sourceLotId: "lot_demo_10", sizeLabel: "12 oz",  sizeOz: 12,   grind: "Whole bean", bagSku: "BAG-12-WHT",  retailPrice: 17.00, onHandBags: 220, avgDailySales: 9.6, lastRoastAt: now -  1 * MS_DAY, status: "active" },
  { skuCode: "DECAF-12-WB",    name: "Colombia Decaf — 12oz",               coffeeName: "Colombia Decaf",         sourceLotId: "lot_demo_04", sizeLabel: "12 oz",  sizeOz: 12,   grind: "Whole bean", bagSku: "BAG-12-WHT",  retailPrice: 20.00, onHandBags: 56,  avgDailySales: 3.4, lastRoastAt: now -  5 * MS_DAY, status: "active" },
  { skuCode: "DECAF-12-GR",    name: "Colombia Decaf — 12oz Ground",        coffeeName: "Colombia Decaf",         sourceLotId: "lot_demo_04", sizeLabel: "12 oz",  sizeOz: 12,   grind: "Ground",     bagSku: "BAG-12-WHT",  retailPrice: 20.00, onHandBags: 14,  avgDailySales: 2.4, lastRoastAt: now - 12 * MS_DAY, status: "active" },
  { skuCode: "HOUSE-5LB",      name: "House Blend — 5lb wholesale",         coffeeName: "House Blend",            sourceLotId: "lot_demo_10", sizeLabel: "5 lb",   sizeOz: 80,   grind: "Whole bean", bagSku: "BAG-5LB-KFT", retailPrice: 78.00, onHandBags: 32,  avgDailySales: 2.8, lastRoastAt: now -  1 * MS_DAY, status: "active" },
  { skuCode: "ESP-5LB",        name: "Espresso Blend — 5lb wholesale",      coffeeName: "Espresso Blend",         sourceLotId: "lot_demo_07", sizeLabel: "5 lb",   sizeOz: 80,   grind: "Whole bean", bagSku: "BAG-5LB-KFT", retailPrice: 84.00, onHandBags: 41,  avgDailySales: 3.6, lastRoastAt: now -  3 * MS_DAY, status: "active" },
  { skuCode: "RIVERA-12-WB",   name: "Colombia La Riviera Gesha — 12oz",    coffeeName: "Colombia La Riviera",    sourceLotId: "lot_demo_06", sizeLabel: "12 oz",  sizeOz: 12,   grind: "Whole bean", bagSku: "BAG-12-BLK",  retailPrice: 38.00, onHandBags: 6,   avgDailySales: 1.2, lastRoastAt: now - 22 * MS_DAY, status: "active" },
  { skuCode: "SAMP-4OZ",       name: "Origin Sampler — 4oz set of 4",       coffeeName: "Sampler — assorted",      sourceLotId: null,         sizeLabel: "4×4 oz", sizeOz: 16,   grind: "Whole bean", bagSku: "BAG-4OZ-CLR", retailPrice: 28.00, onHandBags: 22,  avgDailySales: 1.8, lastRoastAt: now -  7 * MS_DAY, status: "active" },
];

/* Roast batches — chronological log linking a green lot to a finished
   SKU. Yield % is realistic (84-88% retention after weight loss in
   the roaster). The Roast batches view reads this directly. */
const ROAST_OPERATORS = ["Josh", "John", "Nathalie"];
const ROAST_PROFILES  = ["City+", "Full City", "City", "Vienna", "Full City+"];
export const DEMO_ROAST_BATCHES = (() => {
  const recipes = [
    { skuCode: "YIRG-12-WB",    lotId: "lot_demo_12", machine: "Loring S15" },
    { skuCode: "GUJI-12-WB",    lotId: "lot_demo_03", machine: "Loring S15" },
    { skuCode: "KENYA-12-WB",   lotId: "lot_demo_05", machine: "Loring S15" },
    { skuCode: "COL-ESP-12-WB", lotId: "lot_demo_01", machine: "Probat P25" },
    { skuCode: "COL-PAR-12-WB", lotId: "lot_demo_02", machine: "Loring S15" },
    { skuCode: "GTM-12-WB",     lotId: "lot_demo_07", machine: "Probat P25" },
    { skuCode: "HND-12-WB",     lotId: "lot_demo_08", machine: "Loring S15" },
    { skuCode: "BRA-12-WB",     lotId: "lot_demo_10", machine: "Probat P25" },
    { skuCode: "DECAF-12-WB",   lotId: "lot_demo_04", machine: "Probat P25" },
    { skuCode: "HOUSE-5LB",     lotId: "lot_demo_10", machine: "Loring S15" },
    { skuCode: "ESP-5LB",       lotId: "lot_demo_07", machine: "Loring S15" },
    { skuCode: "RIVERA-12-WB",  lotId: "lot_demo_06", machine: "Loring S15" },
  ];
  let seed = 9181;
  const rng = () => { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; };
  const out = [];
  let batchN = 1;
  for (let day = 60; day >= 0; day--) {
    const dailyRoasts = day < 7 ? 1 + Math.floor(rng() * 3) : Math.floor(rng() * 3);
    for (let r = 0; r < dailyRoasts; r++) {
      const recipe = recipes[Math.floor(rng() * recipes.length)];
      const greenLbsIn = Math.round((24 + rng() * 38) * 10) / 10;
      const yieldPct = +(0.84 + rng() * 0.04).toFixed(3);
      const roastedLbsOut = +(greenLbsIn * yieldPct).toFixed(2);
      const sizeOz = recipe.skuCode.includes("5LB") ? 80 : 12;
      const bagsProduced = Math.floor((roastedLbsOut * 16) / sizeOz);
      const at = now - day * MS_DAY - Math.floor(rng() * MS_DAY * 0.6);
      out.push({
        id: `BATCH-2026-${String(batchN).padStart(4, "0")}`,
        at,
        roastDate: new Date(at).toISOString().slice(0, 10),
        skuCode: recipe.skuCode,
        inputLotId: recipe.lotId,
        greenLbsIn,
        roastedLbsOut,
        yieldPct,
        machine: recipe.machine,
        operator: ROAST_OPERATORS[Math.floor(rng() * ROAST_OPERATORS.length)],
        profile: ROAST_PROFILES[Math.floor(rng() * ROAST_PROFILES.length)],
        bagsProduced,
        qcStatus: rng() < 0.92 ? "passed" : "flagged",
        notes: rng() < 0.15 ? "Above-target development; review next batch." : "",
      });
      batchN++;
    }
  }
  return out.sort((a, b) => b.at - a.at);
})();

/* Packaging + supplies inventory — bags, boxes, valves, labels, etc.
   Unlike green coffee these aren't lots with weight ledgers; they're
   countable units (each / case / roll) with a reorder point. */
export const DEMO_SUPPLIES = [
  { id: "sup_01", name: "12oz Kraft pouch — block bottom",        category: "Bags",        sku: "BAG-12-KFT", unit: "each", onHand:  840, reorderAt: 500, reorderQty: 2000, costPerUnit: 0.42, vendor: "Roastar",       lastReceivedAt: now - 14 * MS_DAY },
  { id: "sup_02", name: "12oz Black foil bag — tin tie",          category: "Bags",        sku: "BAG-12-BLK", unit: "each", onHand:  120, reorderAt: 250, reorderQty: 1000, costPerUnit: 0.55, vendor: "Pacific Bag",   lastReceivedAt: now - 48 * MS_DAY },
  { id: "sup_03", name: "12oz White poly bag",                    category: "Bags",        sku: "BAG-12-WHT", unit: "each", onHand: 1620, reorderAt: 500, reorderQty: 2000, costPerUnit: 0.38, vendor: "Roastar",       lastReceivedAt: now -  7 * MS_DAY },
  { id: "sup_04", name: "5lb Kraft retail bag",                   category: "Bags",        sku: "BAG-5LB-KFT", unit: "each", onHand:  240, reorderAt: 100, reorderQty:  500, costPerUnit: 1.85, vendor: "Pacific Bag",   lastReceivedAt: now - 22 * MS_DAY },
  { id: "sup_05", name: "1lb Whole-bean bag — kraft",             category: "Bags",        sku: "BAG-1LB-KFT", unit: "each", onHand:   72, reorderAt: 200, reorderQty: 1000, costPerUnit: 0.48, vendor: "Roastar",       lastReceivedAt: now - 60 * MS_DAY },
  { id: "sup_06", name: "4oz Sample bag — clear poly",            category: "Bags",        sku: "BAG-4OZ-CLR", unit: "each", onHand:  410, reorderAt: 200, reorderQty: 1000, costPerUnit: 0.18, vendor: "Roastar",       lastReceivedAt: now - 31 * MS_DAY },
  { id: "sup_07", name: "Shipping box 6×6×6",                      category: "Boxes",       sku: "BOX-6X6",   unit: "each", onHand:  185, reorderAt: 100, reorderQty:  500, costPerUnit: 0.65, vendor: "ULINE",         lastReceivedAt: now - 11 * MS_DAY },
  { id: "sup_08", name: "Shipping box 8×8×8",                      category: "Boxes",       sku: "BOX-8X8",   unit: "each", onHand:   42, reorderAt:  60, reorderQty:  300, costPerUnit: 0.85, vendor: "ULINE",         lastReceivedAt: now - 38 * MS_DAY },
  { id: "sup_09", name: "Shipping box 12×12×6",                    category: "Boxes",       sku: "BOX-12X12", unit: "each", onHand:    8, reorderAt:  40, reorderQty:  200, costPerUnit: 1.45, vendor: "ULINE",         lastReceivedAt: now - 95 * MS_DAY },
  { id: "sup_10", name: "Subscription mailer 9×12",                category: "Boxes",       sku: "BOX-MAIL",  unit: "each", onHand:  324, reorderAt: 150, reorderQty:  600, costPerUnit: 0.72, vendor: "Sticker Mule",  lastReceivedAt: now - 18 * MS_DAY },
  { id: "sup_11", name: "One-way degassing valve",                 category: "Valves",      sku: "VLV-OW",    unit: "each", onHand: 4200, reorderAt:1000, reorderQty: 5000, costPerUnit: 0.05, vendor: "Pacific Bag",   lastReceivedAt: now - 26 * MS_DAY },
  { id: "sup_12", name: "Pre-printed front label (4×3)",           category: "Labels",      sku: "LBL-FRT-4X3", unit: "roll", onHand:   18, reorderAt:  10, reorderQty:   50, costPerUnit: 24,   vendor: "Sticker Mule",  lastReceivedAt: now -  4 * MS_DAY },
  { id: "sup_13", name: "Address / shipping label (4×6 thermal)",  category: "Labels",      sku: "LBL-ADDR",  unit: "roll", onHand:    6, reorderAt:   8, reorderQty:   30, costPerUnit: 16,   vendor: "ULINE",         lastReceivedAt: now - 15 * MS_DAY },
  { id: "sup_14", name: "Packing tape — clear 2in",                category: "Tape",        sku: "TPE-CLR",   unit: "roll", onHand:   45, reorderAt:  20, reorderQty:   72, costPerUnit: 3.80, vendor: "ULINE",         lastReceivedAt: now -  9 * MS_DAY },
  { id: "sup_15", name: "Brown kraft filler paper",                category: "Filler",      sku: "FLR-KFT",   unit: "case", onHand:    3, reorderAt:   2, reorderQty:    6, costPerUnit: 28,   vendor: "ULINE",         lastReceivedAt: now - 52 * MS_DAY },
  { id: "sup_16", name: "Cupping cups — 6oz tasting",              category: "Lab",         sku: "CUP-6OZ",   unit: "case", onHand:    2, reorderAt:   2, reorderQty:    4, costPerUnit: 38,   vendor: "Stout Tabletop", lastReceivedAt: now - 70 * MS_DAY },
];

// Synthesize realistic event histories — receipt at arrival, then a
// scattered series of roast events that reduces the lot weight from
// initial → current. The roast cadence is randomized per lot so the
// 30-day burn rate chart on the inventory dashboard has texture.
(function attachEvents() {
  let rngSeed = 42;
  const rng = () => { rngSeed = (rngSeed * 9301 + 49297) % 233280; return rngSeed / 233280; };
  for (const lot of DEMO_LOTS) {
    const used = +(lot.initialWeightLbs - lot.currentWeightLbs).toFixed(2);
    const arrivalAt = new Date(lot.arrivalDate + "T00:00:00").getTime();
    const events = [
      { id: `evt-${lot.id}-r0`, type: "receipt", weightLbs: lot.initialWeightLbs, at: arrivalAt, note: "Initial receipt", by: null },
    ];
    if (used <= 0) { lot.events = events; continue; }
    // Spread N roast events across the lot's lifetime, ending no
    // earlier than 2 days ago so 'days runway' calc has signal.
    const span = Math.max(1, Date.now() - arrivalAt - 2 * MS_DAY);
    const nRoasts = Math.max(2, Math.min(14, Math.round(used / 28)));
    let remaining = used;
    for (let i = 0; i < nRoasts; i++) {
      const isLast = i === nRoasts - 1;
      const draw = isLast ? remaining : +(remaining * (0.18 + rng() * 0.32)).toFixed(2);
      const at = arrivalAt + Math.round((i + 1) * span / (nRoasts + 1) + (rng() - 0.5) * span * 0.08);
      events.push({
        id: `evt-${lot.id}-rst${i}`,
        type: rng() < 0.08 ? "sample" : "roast",
        weightLbs: -draw,
        at,
        note: rng() < 0.08 ? "Sample roast" : `Production roast — ${(draw / 12).toFixed(1)} batches`,
        by: null,
      });
      remaining = +(remaining - draw).toFixed(2);
      if (remaining <= 0) break;
    }
    lot.events = events;
  }
})();

// ── Cuppings — 4 sessions across 6 months, each holds multiple
//    samples scored side-by-side. The wrapLegacyCupping shim already
//    handles the old single-coffee shape, so this file just emits
//    the new session shape directly.
const cof = (idx, data) => ({
  id: `cof_demo_${idx}`,
  ...data,
});

// Three demo cuppers we attribute per-sample scoring records to so
// the multi-cupper tabs in the UI have content out of the box.
// Names match DEMO_CUPPERS below.
const DEMO_CUPPER_IDS = ["cup_demo_josh", "cup_demo_john", "cup_demo_nathalie"];

// Tiny per-cupper notes pool so each cupping record reads as a real
// person's quick take rather than empty filler.
const DEMO_CUPPER_NOTES = {
  cup_demo_josh:     ["Bright but disciplined. Loved the finish.", "Delicate florals, structured body.", "Acidity skewed citrus for me — clean.", "Felt slightly muted on the second cup."],
  cup_demo_john:     ["Cocoa-leaning here, more body than fruit.", "Solid blend candidate. Nothing stuck out.", "Picking up brown sugar and dried fruit.", "Acidity sat lower than I'd want for SO."],
  cup_demo_nathalie: ["Floral, jasmine-y, lovely length.", "Stone fruit forward. Sweetness on the back.", "Clean and dialed; would re-order.", "Felt one-dimensional after second pour."],
};

// Maps the demo cupper id to a display name we stamp onto each
// cupping record, so the tabs read the name straight from the
// record (no roster lookup required).
const DEMO_CUPPER_NAMES = {
  cup_demo_josh: "Josh",
  cup_demo_john: "John",
  cup_demo_nathalie: "Nathalie",
};

// Build N synthetic per-cupper records by perturbing the sample's
// canonical scores by ±0.25 per attribute (within SCA bounds).
function buildCupperRecords(sample, cupperIds) {
  const baseScores = sample.scores || {};
  const primary = ["fragrance", "flavor", "aftertaste", "acidity", "body", "balance", "overall"];
  return cupperIds.map((cupperId, i) => {
    // Deterministic offsets keyed on cupper position so the demo is
    // stable across reloads.
    const offsets = [-0.25, 0, 0.25];
    const off = offsets[i % offsets.length];
    const scores = {};
    for (const k of primary) {
      const v = Number(baseScores[k]);
      if (!Number.isFinite(v)) continue;
      scores[k] = Math.max(6, Math.min(10, +(v + off).toFixed(2)));
    }
    // Secondary checks default to 10; copy whatever the sample has.
    for (const k of ["uniformity", "cleanCup", "sweetness"]) {
      if (baseScores[k] != null) scores[k] = baseScores[k];
    }
    const notesPool = DEMO_CUPPER_NOTES[cupperId] || [""];
    return {
      cupperId,
      cupperName: DEMO_CUPPER_NAMES[cupperId] || "",
      scores,
      descriptors: sample.descriptors ? { ...sample.descriptors } : {},
      defects: sample.defects || 0,
      notes: notesPool[i % notesPool.length] || "",
      scoredAt: Date.now(),
    };
  });
}

// Decorates a session by attaching `cuppings: [...]` to every sample.
// Cuppers are session-scoped: the same `cupperIds` array is used for
// every sample in the session, mirroring real-world flow where you
// invite cuppers once and they score all samples on the table. Sample-
// level scores are left empty so the Average view computes from the
// per-cupper records dynamically.
//
// `treatments` lets a session opt specific samples (by index) into:
//   - { adminOverride: true }   — keep the canonical scores so Main
//     renders as an admin-locked override.
//   - { excludeCupperAt: n }    — flag the n-th cupper as excluded
//     from the Average on that sample, surfacing the EXCLUDED chip.
function attachDemoCuppers(session, cupperIds = DEMO_CUPPER_IDS.slice(0, 2), treatments = {}) {
  return {
    ...session,
    coffees: (session.coffees || []).map((co, idx) => {
      const cuppings = buildCupperRecords(co, cupperIds);
      const t = treatments[idx] || {};
      if (t.excludeCupperAt != null && cuppings[t.excludeCupperAt]) {
        cuppings[t.excludeCupperAt] = {
          ...cuppings[t.excludeCupperAt],
          excludedFromAverage: true,
        };
      }
      if (t.adminOverride) {
        return { ...co, cuppings };
      }
      return {
        ...co,
        cuppings,
        scores: null,
        descriptors: null,
        defects: 0,
        total: 0,
      };
    }),
  };
}
export const DEMO_CUPPINGS = [
  // ── Session 1 — Q4 lineup screening (~6 months ago) ─────────────
  {
    id: "cup_session_q4",
    name: "Q4 Lineup Screening",
    cupperName: "Dev Patel",
    cuppingDate: new Date(now - 165 * MS_DAY).toISOString().slice(0, 10),
    notes: "Bench-marking 5 samples for the winter lineup. Looking for new SO candidates and a Gesha-tier offering.",
    coffees: [
      cof("q4_1", {
        coffeeName: "Honduras Marcala — Finca La Maravilla",
        sourcedFrom: "Cafe Imports",
        roastDate: new Date(now - 167 * MS_DAY).toISOString().slice(0, 10),
        scores: { fragrance: 7.5, flavor: 7.75, aftertaste: 7.5, acidity: 7.75, body: 8.0, balance: 7.75, overall: 7.75, uniformity: 10, cleanCup: 9, sweetness: 10 },
        defects: 1, total: 78.75, status: "rejected",
        descriptors: { fragrance: "brown sugar, mild cocoa", flavor: "flat chocolate, low acidity", aftertaste: "short, slightly woody" },
        notes: "Didn't meet bar. Muted acidity, not enough brightness for our profile.",
      }),
      cof("q4_2", {
        coffeeName: "Panama Boquete — Hacienda La Esmeralda Gesha",
        sourcedFrom: "Ally Coffee",
        roastDate: new Date(now - 167 * MS_DAY).toISOString().slice(0, 10),
        scores: { fragrance: 9.5, flavor: 9.25, aftertaste: 9.0, acidity: 9.25, body: 8.75, balance: 9.25, overall: 9.5, uniformity: 10, cleanCup: 10, sweetness: 10 },
        defects: 0, total: 94.5, status: "approved",
        descriptors: { fragrance: "jasmine, bergamot, lychee", flavor: "tropical fruit, earl grey, rose water", aftertaste: "incredibly long, floral" },
        notes: "Best Gesha we've run in 2 years. Considering single-cup offering at higher price point.",
      }),
      cof("q4_3", {
        coffeeName: "Ethiopia Yirgacheffe — Kochere Washed",
        sourcedFrom: "Osito Coffee",
        roastDate: new Date(now - 167 * MS_DAY).toISOString().slice(0, 10),
        scores: { fragrance: 9.0, flavor: 8.75, aftertaste: 8.75, acidity: 9.0, body: 8.5, balance: 8.75, overall: 8.75, uniformity: 10, cleanCup: 10, sweetness: 10 },
        defects: 0, total: 91.5, status: "approved",
        descriptors: { fragrance: "bergamot, peach, jasmine", flavor: "lemon curd, white peach, tea-like", aftertaste: "clean, lingering citrus" },
        notes: "Classic Yirg washed. Going into single origin rotation.",
      }),
      cof("q4_4", {
        coffeeName: "Rwanda Nyamasheke — Gashonga Washed",
        sourcedFrom: "Red Fox Coffee Merchants",
        roastDate: new Date(now - 167 * MS_DAY).toISOString().slice(0, 10),
        scores: { fragrance: 8.75, flavor: 8.75, aftertaste: 8.5, acidity: 8.75, body: 8.5, balance: 8.5, overall: 8.75, uniformity: 10, cleanCup: 10, sweetness: 10 },
        defects: 0, total: 88.5, status: "approved",
        descriptors: { fragrance: "red hibiscus, raspberry", flavor: "blackcurrant, brown sugar, citrus zest", aftertaste: "juicy, lingering" },
        notes: "Lovely Rwandan cup. Good alternative to Kenya in the lineup.",
      }),
      cof("q4_5", {
        coffeeName: "Myanmar Shan State — Ywar Ngan",
        sourcedFrom: "Cafe Imports",
        roastDate: new Date(now - 167 * MS_DAY).toISOString().slice(0, 10),
        scores: { fragrance: 7.25, flavor: 7.25, aftertaste: 7.0, acidity: 7.0, body: 8.25, balance: 7.0, overall: 7.25, uniformity: 10, cleanCup: 8, sweetness: 9 },
        defects: 2, total: 74.0, status: "rejected",
        descriptors: { fragrance: "musty, hay", flavor: "earthy, flat, low sweetness", aftertaste: "brief, off-notes" },
        notes: "Ferment defects present. Too risky for our lineup. Pass.",
      }),
    ],
  },

  // ── Session 2 — Winter calibration (~4 months ago) ──────────────
  {
    id: "cup_session_winter",
    name: "Winter Specialty Calibration",
    cupperName: "Miriam Holt",
    cuppingDate: new Date(now - 105 * MS_DAY).toISOString().slice(0, 10),
    notes: "Mid-season check on the four anchors. Comparing year-over-year.",
    coffees: [
      cof("w_1", {
        coffeeName: "Colombia Nariño — Los Nogales Washed",
        sourcedFrom: "Cafe Imports",
        roastDate: new Date(now - 107 * MS_DAY).toISOString().slice(0, 10),
        scores: { fragrance: 8.75, flavor: 8.75, aftertaste: 8.5, acidity: 8.5, body: 8.75, balance: 8.5, overall: 8.5, uniformity: 10, cleanCup: 10, sweetness: 10 },
        defects: 0, total: 87.25, status: "approved",
        descriptors: { fragrance: "caramel, peach, vanilla", flavor: "stone fruit, toffee, mild citrus", aftertaste: "smooth, long" },
        notes: "Could complement La Esperanza well in the blend. Ordering a bag.",
      }),
      cof("w_2", {
        coffeeName: "Nicaragua Matagalpa — Finca San Martín",
        sourcedFrom: "Red Fox Coffee Merchants",
        roastDate: new Date(now - 107 * MS_DAY).toISOString().slice(0, 10),
        scores: { fragrance: 8.5, flavor: 8.5, aftertaste: 8.5, acidity: 8.5, body: 8.5, balance: 8.5, overall: 8.5, uniformity: 10, cleanCup: 10, sweetness: 10 },
        defects: 0, total: 85.5, status: "approved",
        descriptors: { fragrance: "milk chocolate, dried cherry", flavor: "cocoa, cherry, walnut", aftertaste: "clean, round" },
        notes: "Solid specialty lot. Reliable and affordable — good blend anchor.",
      }),
      cof("w_3", {
        coffeeName: "El Salvador Santa Ana — Los Planes Honey",
        sourcedFrom: "Ally Coffee",
        roastDate: new Date(now - 107 * MS_DAY).toISOString().slice(0, 10),
        scores: { fragrance: 8.5, flavor: 8.75, aftertaste: 8.5, acidity: 8.5, body: 8.75, balance: 8.5, overall: 8.5, uniformity: 10, cleanCup: 10, sweetness: 10 },
        defects: 0, total: 86.0, status: "approved",
        descriptors: { fragrance: "brown sugar, apricot", flavor: "peach jam, toffee, mild spice", aftertaste: "round, warm" },
        notes: "Honey process adds body without muddying clarity. Will re-order.",
      }),
      cof("w_4", {
        coffeeName: "Kenya Kirinyaga — Kiria AA",
        sourcedFrom: "Ally Coffee",
        roastDate: new Date(now - 107 * MS_DAY).toISOString().slice(0, 10),
        scores: { fragrance: 9.0, flavor: 9.0, aftertaste: 8.75, acidity: 9.0, body: 8.75, balance: 8.75, overall: 9.0, uniformity: 10, cleanCup: 10, sweetness: 10 },
        defects: 0, total: 92.25, status: "approved",
        descriptors: { fragrance: "blackcurrant, tomato, pomelo", flavor: "grapefruit, cherry, dark honey", aftertaste: "long, juicy, bright" },
        notes: "Best Kenya we've had this crop. Will feature as limited single origin.",
      }),
    ],
  },

  // ── Session 3 — Spring lineup pre-launch (~2 months ago) ────────
  {
    id: "cup_session_spring",
    name: "Spring Lineup Pre-Launch",
    cupperName: "Dev Patel",
    cuppingDate: new Date(now - 50 * MS_DAY).toISOString().slice(0, 10),
    notes: "Final picks for the spring rotation. Naturals on the table for the first time this year.",
    coffees: [
      cof("sp_1", {
        coffeeName: "Sumatra Mandheling — Lintong Wet-Hulled",
        sourcedFrom: "Cafe Imports",
        roastDate: new Date(now - 52 * MS_DAY).toISOString().slice(0, 10),
        scores: { fragrance: 7.5, flavor: 7.75, aftertaste: 7.5, acidity: 7.0, body: 8.5, balance: 7.5, overall: 7.75, uniformity: 10, cleanCup: 9, sweetness: 10 },
        defects: 1, total: 78.5, status: "rejected",
        descriptors: { fragrance: "earthy, herbal", flavor: "earthy, cedar, tobacco", aftertaste: "flat" },
        notes: "Classic Sumatra character but too muted for our lineup right now.",
      }),
      cof("sp_2", {
        coffeeName: "Peru Cajamarca — Chirinos",
        sourcedFrom: "Red Fox Coffee Merchants",
        roastDate: new Date(now - 52 * MS_DAY).toISOString().slice(0, 10),
        scores: { fragrance: 8.0, flavor: 8.0, aftertaste: 7.75, acidity: 8.0, body: 8.25, balance: 8.0, overall: 8.0, uniformity: 10, cleanCup: 10, sweetness: 10 },
        defects: 0, total: 82.0, status: "approved",
        descriptors: { fragrance: "brown sugar", flavor: "cocoa, baker's chocolate, lightly floral", aftertaste: "short" },
        notes: "",
      }),
      cof("sp_3", {
        coffeeName: "Brazil Minas Gerais — Fazenda Barra Natural",
        sourcedFrom: "Cafe Imports",
        roastDate: new Date(now - 52 * MS_DAY).toISOString().slice(0, 10),
        scores: { fragrance: 8.0, flavor: 8.0, aftertaste: 8.0, acidity: 8.0, body: 8.5, balance: 8.0, overall: 8.0, uniformity: 10, cleanCup: 10, sweetness: 10 },
        defects: 0, total: 82.5, status: "approved",
        descriptors: { fragrance: "almond, milk chocolate", flavor: "nut, malted, orange peel", aftertaste: "clean, short" },
        notes: "Good espresso base. Will use in Elion Blend.",
      }),
      cof("sp_4", {
        coffeeName: "Ethiopia Guji — Hambela Natural",
        sourcedFrom: "Osito Coffee",
        roastDate: new Date(now - 52 * MS_DAY).toISOString().slice(0, 10),
        scores: { fragrance: 9.0, flavor: 9.0, aftertaste: 8.75, acidity: 8.75, body: 8.5, balance: 8.75, overall: 9.0, uniformity: 10, cleanCup: 10, sweetness: 10 },
        defects: 0, total: 91.75, status: "approved",
        descriptors: { fragrance: "blueberry, strawberry jam", flavor: "blueberry, chocolate-covered strawberry, wine", aftertaste: "fruity, long, sweet" },
        notes: "Unmistakable natural Ethiopia. Customer favorite for bottled cold brew.",
      }),
      cof("sp_5", {
        coffeeName: "Guatemala Huehuetenango — El Injerto",
        sourcedFrom: "Red Fox Coffee Merchants",
        roastDate: new Date(now - 52 * MS_DAY).toISOString().slice(0, 10),
        scores: { fragrance: 8.75, flavor: 8.75, aftertaste: 8.5, acidity: 8.75, body: 8.5, balance: 8.5, overall: 8.75, uniformity: 10, cleanCup: 10, sweetness: 10 },
        defects: 0, total: 88.5, status: "approved",
        descriptors: { fragrance: "dark chocolate, toasted nut", flavor: "cocoa, raisin, baking spice", aftertaste: "long, warming" },
        notes: "",
      }),
    ],
  },

  // ── Session 4 — April panel (most recent) ───────────────────────
  {
    id: "cup_session_recent",
    name: "April Tasting Panel",
    cupperName: "Miriam Holt",
    cuppingDate: new Date(now - 6 * MS_DAY).toISOString().slice(0, 10),
    notes: "Three samples we want fresh eyes on before locking the next blend.",
    coffees: [
      cof("r_1", {
        coffeeName: "Costa Rica Tarrazú — La Minita Honey",
        sourcedFrom: "Ally Coffee",
        roastDate: new Date(now - 8 * MS_DAY).toISOString().slice(0, 10),
        scores: { fragrance: 8.5, flavor: 8.75, aftertaste: 8.5, acidity: 8.5, body: 8.75, balance: 8.5, overall: 8.5, uniformity: 10, cleanCup: 10, sweetness: 10 },
        defects: 0, total: 88.0, status: "approved",
        descriptors: { fragrance: "orange blossom, honey", flavor: "stone fruit, panela, dark cocoa", aftertaste: "round, clean" },
        notes: "",
      }),
      cof("r_2", {
        coffeeName: "Colombia Huila — La Esperanza",
        sourcedFrom: "Cafe Imports",
        roastDate: new Date(now - 8 * MS_DAY).toISOString().slice(0, 10),
        scores: { fragrance: 8.5, flavor: 8.75, aftertaste: 8.5, acidity: 8.5, body: 8.5, balance: 8.75, overall: 8.5, uniformity: 10, cleanCup: 10, sweetness: 10 },
        defects: 0, total: 88.0, status: "approved",
        descriptors: { fragrance: "caramel, red apple", flavor: "milk chocolate, cherry, brown sugar", aftertaste: "smooth, balanced" },
        notes: "Consistent year-round anchor. Flagship blend component.",
      }),
      cof("r_3", {
        coffeeName: "Kenya Nyeri — Karatu AA",
        sourcedFrom: "Ally Coffee",
        roastDate: new Date(now - 8 * MS_DAY).toISOString().slice(0, 10),
        scores: { fragrance: 9.0, flavor: 9.0, aftertaste: 8.75, acidity: 9.0, body: 8.5, balance: 8.5, overall: 8.75, uniformity: 10, cleanCup: 10, sweetness: 10 },
        defects: 0, total: 91.5, status: "pending",
        descriptors: { fragrance: "black currant, tomato leaf", flavor: "blackberry, grapefruit, honey", aftertaste: "lingering, juicy" },
        notes: "Textbook Nyeri. Acidity is bright but not sharp.",
      }),
    ],
  },
].map((s, i) => {
  // Each session has a fixed pair of cuppers across all its samples
  // (cuppers are session-scoped, not per-sample).
  //   Session 0 (Q4 screening)        → Josh + John;
  //                                     sample 0 excludes John from avg.
  //   Session 1 (Winter calibration)  → John + Nathalie.
  //   Session 2 (Spring pre-launch)   → Josh + Nathalie;
  //                                     sample 1 keeps an admin override.
  //   Session 3 (April panel)         → Josh + John + Nathalie.
  const rosters = [
    ["cup_demo_josh", "cup_demo_john"],
    ["cup_demo_john", "cup_demo_nathalie"],
    ["cup_demo_josh", "cup_demo_nathalie"],
    ["cup_demo_josh", "cup_demo_john", "cup_demo_nathalie"],
  ];
  const roster = rosters[i] || ["cup_demo_josh", "cup_demo_john"];
  if (i === 0) return attachDemoCuppers(s, roster, { 0: { excludeCupperAt: 1 } });
  if (i === 2) return attachDemoCuppers(s, roster, { 1: { adminOverride: true } });
  return attachDemoCuppers(s, roster);
});

// ── Ready-to-go orders (Produced bucket) — 6 months with growth ──
const ACT_PRODUCTS = [
  { name: "La Esperanza",    qty: 15 },
  { name: "El Paraíso",      qty: 12 },
  { name: "PCF Decaf",       qty: 10 },
  { name: "Finca La Riviera",qty: 18 },
  { name: "Elion Blend",  qty: 20 },
  { name: "Ethiopia Guji",   qty: 15 },
  { name: "Kenya Nyeri",     qty: 12 },
];
// Default cupping sources surfaced when the user lands with an empty
// roster (first-run demo). Hand-seeded so the Add-coffee form has
// real-looking options out of the box.
export const DEMO_CUPPING_SOURCES = [
  { id: "src_demo_kings",    name: "Kings of Coffee", type: "importer", region: "Colombia, Ethiopia", contactName: "Josh",    contactEmail: "", notes: "" },
  { id: "src_demo_origin",   name: "Origin Direct",   type: "importer", region: "Colombia",            contactName: "John",    contactEmail: "", notes: "" },
  { id: "src_demo_spiritas", name: "Spiritas",        type: "importer", region: "Ethiopia",            contactName: "Nathalie",contactEmail: "", notes: "" },
];

// Default cuppers — names referenced on the demo source contacts so
// the panel feels lived-in.
export const DEMO_CUPPERS = [
  { id: "cup_demo_josh",     name: "Josh",     email: "" },
  { id: "cup_demo_john",     name: "John",     email: "" },
  { id: "cup_demo_nathalie", name: "Nathalie", email: "" },
];

/* Standalone samples — pre-cupping intake. These are coffees that have
   landed on the bench but haven't been attached to a session yet, so
   they show up in the New-cupping modal's picker. The names are
   intentionally NOT in DEMO_CUPPINGS so the operator sees fresh
   options that still need to be scored. */
export const DEMO_SAMPLES = [
  {
    id: "samp_demo_01",
    coffeeName: "Ethiopia Yirgacheffe — Kochere Washed",
    origin: "Yirgacheffe, Ethiopia",
    process: "Washed",
    variety: "Heirloom",
    sourcedFrom: "Spiritas",
    expectedNotes: "jasmine, bergamot, lemon zest",
    roastDate: "",
    receivedAt: now - 4 * MS_DAY,
    notes: "Pre-shipment offer sample.",
  },
  {
    id: "samp_demo_02",
    coffeeName: "Rwanda Nyamasheke — Gashonga Washed",
    origin: "Nyamasheke, Rwanda",
    process: "Washed",
    variety: "Bourbon",
    sourcedFrom: "Kings of Coffee",
    expectedNotes: "black tea, currant, honey",
    roastDate: "",
    receivedAt: now - 7 * MS_DAY,
    notes: "Microlot pulled for Q3 lineup screening.",
  },
  {
    id: "samp_demo_03",
    coffeeName: "Colombia Nariño — Los Nogales Washed",
    origin: "Nariño, Colombia",
    process: "Washed",
    variety: "Caturra",
    sourcedFrom: "Origin Direct",
    expectedNotes: "panela, caramel, red apple",
    roastDate: "",
    receivedAt: now - 11 * MS_DAY,
    notes: "Replacement for current Colombian seasonal.",
  },
  {
    id: "samp_demo_04",
    coffeeName: "Honduras Marcala — Finca La Maravilla",
    origin: "Marcala, Honduras",
    process: "Honey",
    variety: "Pacamara",
    sourcedFrom: "Kings of Coffee",
    expectedNotes: "stone fruit, milk chocolate, brown sugar",
    roastDate: "",
    receivedAt: now - 2 * MS_DAY,
    notes: "Producer comp set sample.",
  },
  {
    id: "samp_demo_05",
    coffeeName: "Panama Boquete — Hacienda La Esmeralda Gesha",
    origin: "Boquete, Panama",
    process: "Washed",
    variety: "Gesha",
    sourcedFrom: "Spiritas",
    expectedNotes: "bergamot, white peach, jasmine, honey",
    roastDate: "",
    receivedAt: now - 1 * MS_DAY,
    notes: "Aspirational lot — for pricing study.",
  },
];

const ACT_CUSTOMERS = [
  "Mika Nakamura", "Arturo Vasquez", "Priya Srinivasan",
  "Jordan Lee", "Sam Rivera", "Casey Brooks", "Morgan Hill",
  "Elise Bergstrom", "Nathan O'Brien", "Camille Laurent",
];
export const DEMO_PRODUCED_ORDERS = (() => {
  const rng2 = mulberry32(77);
  const r2 = (a, b) => a + Math.floor(rng2() * (b - a + 1));
  const pick2 = (arr) => arr[Math.floor(rng2() * arr.length)];
  const orders = [];
  let orderNum = 4820;
  const PROD_DAYS = 730; // 2 years
  // 400x compounding growth: near-zero batches 2 years ago → ~40 batches/day today
  // Peak: ~40 batches/day weekdays, ~10 on Saturdays
  for (let d = PROD_DAYS - 1; d >= 0; d--) {
    const dow = new Date(now - d * MS_DAY).getDay();
    if (dow === 0) continue; // closed Sundays
    // progress: 0 = oldest, 1 = today
    const progress = (PROD_DAYS - 1 - d) / (PROD_DAYS - 1);
    // 400x exponential growth factor — floor at 0.02 so year-1 has a trickle
    const gm = Math.max(0.02, Math.pow(400, progress) / 400);
    // Peak batches/day (at gm=1): ~40 weekday, ~10 Saturday
    const peakWeekday = 40;
    const peakSat = 10;
    const peak = dow === 6 ? peakSat : peakWeekday;
    const expectedBatches = Math.max(0, peak * gm * (0.7 + rng2() * 0.6));
    // At very low growth, skip most days
    if (expectedBatches < 0.5 && rng2() > expectedBatches) continue;
    const batchesThisDay = Math.max(1, Math.round(expectedBatches));
    for (let b = 0; b < batchesThisDay; b++) {
      const prod = pick2(ACT_PRODUCTS);
      const producedAt = now - d * MS_DAY - r2(6, 16) * 3600000 + b * 1800000;
      orders.push({
        shopifyId: `demo_act_${orderNum}`,
        id: `#${orderNum}`,
        customer: pick2(ACT_CUSTOMERS),
        date: new Date(producedAt).toLocaleDateString("en-US", { month: "short", day: "numeric" }),
        items: [{ productId: 100 + r2(1, 7), name: prod.name, variant: "12oz Whole Bean", sku: `SKU-${orderNum}`, qty: prod.qty + r2(-3, 5), grams: 340 }],
        total: prod.qty * 22 + r2(0, 60),
        shippingAddress: { address1: "123 Demo St", city: "San Francisco", province: "CA", province_code: "CA", zip: "94110", latitude: null, longitude: null, name: pick2(ACT_CUSTOMERS) },
        producedAt,
      });
      orderNum++;
    }
  }
  return orders;
})();

// ── Roast session history — 6 months with growth ──
function genRoastCurve(rng3, startedAt, durationMin) {
  const samples = [];
  const intervalSec = 15; // sample every 15 sec for smoother curves
  const totalSec = Math.round(durationMin * 60);
  const steps = Math.floor(totalSec / intervalSec);
  const chargeTemp = 348 + rng3() * 6;   // 348–354°F
  const tpTemp     = chargeTemp - 10 - rng3() * 4; // dip ~10–14°F
  const dropTemp   = 400 + rng3() * 12;  // 400–412°F
  const tpPct      = 0.10 + rng3() * 0.05; // TP at 10–15% through roast
  for (let i = 0; i <= steps; i++) {
    const t = i * intervalSec * 1000;
    const pct = i / steps;
    let bt;
    if (pct <= tpPct) {
      // Charge → turning point: gentle dip
      bt = chargeTemp + (tpTemp - chargeTemp) * (pct / tpPct);
    } else {
      // TP → drop: smooth accelerating rise
      const rise = (pct - tpPct) / (1 - tpPct);
      bt = tpTemp + (dropTemp - tpTemp) * (rise * rise * 0.4 + rise * 0.6);
    }
    bt += (rng3() - 0.5) * 1.2; // tiny noise
    const et = bt + 28 + rng3() * 14;
    const rorBase = pct > tpPct && pct < 0.85 ? 10 - (pct - tpPct) * 8 : 2;
    const ror = Math.max(0, rorBase + (rng3() - 0.5) * 1.5);
    samples.push({ ts: startedAt + t, bt: Math.round(bt * 10) / 10, et: Math.round(et * 10) / 10, ror: Math.round(ror * 10) / 10 });
  }
  return samples;
}

export const DEMO_ROASTING_QUEUE = (() => {
  const rng3 = mulberry32(99);
  const r3 = (a, b) => a + Math.floor(rng3() * (b - a + 1));
  const pick3 = (arr) => arr[Math.floor(rng3() * arr.length)];
  const SESSION_PRODUCTS = ["La Esperanza", "El Paraíso", "PCF Decaf", "Finca La Riviera", "Elion Blend", "Ethiopia Guji", "Kenya Nyeri"];
  const completed = [];
  const ROAST_DAYS = 730; // 2 years
  // 400x growth: batch counter starts at B-001 and grows to ~B-2000+ over 2 years
  let batchCounter = 1;

  for (let d = ROAST_DAYS - 1; d >= 1; d--) {
    const dow = new Date(now - d * MS_DAY).getDay();
    if (dow === 0) continue; // no roasting on Sundays

    // progress: 0 = oldest (2y ago), 1 = most recent (yesterday)
    const progress = (ROAST_DAYS - 1 - d) / (ROAST_DAYS - 2);
    // 400x exponential growth factor
    const gm = Math.pow(400, progress) / 400; // 0.0025 → 1.0

    // Decide whether to roast today based on growth factor
    // At peak: roast ~85% of weekdays with 8-20 sessions/day
    const roastProb = Math.min(0.95, gm * 90);
    if (rng3() > roastProb) continue;

    // Sessions grow from nearly 0 → up to 20/day at peak
    const maxSessions = Math.max(1, Math.round(gm * 20));
    const sessionsThisDay = r3(1, maxSessions);

    for (let s = 0; s < sessionsThisDay; s++) {
      const productName = pick3(SESSION_PRODUCTS);
      const totalBatches = r3(1, Math.max(1, Math.round(gm * 4)));
      const batchIndex = s % totalBatches;
      const durationMin = 10 + rng3() * 3;
      const startedAt = now - d * MS_DAY + (6 + s * 0.25) * 3600000;
      const completedAt = startedAt + durationMin * 60000;
      const samples = genRoastCurve(rng3, startedAt, durationMin);
      const fcAt = startedAt + durationMin * 0.78 * 60000;
      const dropAt = startedAt + durationMin * 0.95 * 60000;
      const finalBt = samples[samples.length - 1]?.bt ?? 407;
      const batchNum = `B-${String(batchCounter).padStart(4, "0")}`;
      completed.push({
        batchId: `demo_batch_${batchCounter}`,
        batchNum,
        roastId: `demo_roast_${batchCounter}`,
        productName,
        batchIndex,
        totalBatches,
        sku: `SKU-DEMO-${batchCounter}`,
        roastLevel: pick3(["Light", "Medium-Light", "Medium", "Medium-Dark"]),
        startedAt,
        completedAt,
        finalBt,
        events: [
          { type: "firstCrack", ts: fcAt },
          { type: "drop", ts: dropAt },
        ],
        samples,
      });
      batchCounter++;
    }
  }

  return {
    nextId: null,
    currentId: null,
    currentRoastId: null,
    completed,
    batchNumbers: Object.fromEntries(completed.map(c => [c.batchId, c.batchNum])),
    nextBatchNum: batchCounter,
  };
})();

/* ═══════════════════════════════════════════════════════
   WHOLESALE DEMO DATA
   Store config + products with variants.
   Seeded into the server via /api/wholesale/* on reset.
   ═══════════════════════════════════════════════════════ */
export const DEMO_WHOLESALE_CONFIG = {
  name: "Acme Coffee Roasters",
  slug: "elion-coffee",
  tagline: "Direct-trade specialty coffee for cafés and hospitality.",
  about: "We source green coffee directly from producers in Colombia, Ethiopia, and Kenya — roasted in small batches in San Francisco. All wholesale pricing includes free local delivery on orders over $200.",
  accentColor: "#2C5766",
  published: true,
};

export const DEMO_WHOLESALE_PRODUCTS = [
  {
    name: "La Esperanza",
    category: "Single Origin",
    description: "Juicy stone fruit and caramel sweetness from a family-run farm in Huila. Washed process, 1,800 m. A consistent crowd-pleaser for café pour-over menus.",
    weightOz: 12,
    cost: 14.00,
    price: 22.00,
    active: true,
    photoUrl: "https://images.unsplash.com/photo-1447933601403-0c6688de566e?w=600&h=600&fit=crop&q=80",
    variants: [
      { name: "12 oz", price: 22.00, cost: 14.00, weightOz: 12, sku: "ESP-12" },
      { name: "5 lb", price: 78.00, cost: 50.00, weightOz: 80, sku: "ESP-5LB" },
    ],
  },
  {
    name: "El Paraíso",
    category: "Single Origin",
    description: "Ultra-complex fermentation profiles from Diego Samuel Bermúdez in Cauca. Honey process. Tropical fruit, florals, and a lingering rose-water finish.",
    weightOz: 12,
    cost: 30.00,
    price: 48.00,
    active: true,
    photoUrl: "https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?w=600&h=600&fit=crop&q=80",
    variants: [
      { name: "12 oz", price: 48.00, cost: 30.00, weightOz: 12, sku: "PAR-12" },
    ],
  },
  {
    name: "PCF Decaf",
    category: "Decaf",
    description: "EA-process decaf from Nariño. Milk chocolate and dried apricot. No bitterness, no compromise — your guests won't know the difference.",
    weightOz: 12,
    cost: 13.00,
    price: 20.00,
    active: true,
    photoUrl: "https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=600&h=600&fit=crop&q=80",
    variants: [
      { name: "12 oz", price: 20.00, cost: 13.00, weightOz: 12, sku: "DCF-12" },
      { name: "5 lb", price: 70.00, cost: 46.00, weightOz: 80, sku: "DCF-5LB" },
    ],
  },
  {
    name: "Finca La Riviera",
    category: "Single Origin",
    description: "Natural-process lot from Tolima with clear blueberry jam and dark chocolate notes. Medium-dark roast. Great for espresso-forward menus.",
    weightOz: 12,
    cost: 18.00,
    price: 28.00,
    active: true,
    photoUrl: "https://images.unsplash.com/photo-1461023058943-07fcbe16d735?w=600&h=600&fit=crop&q=80",
    variants: [
      { name: "12 oz", price: 28.00, cost: 18.00, weightOz: 12, sku: "RIV-12" },
      { name: "5 lb", price: 95.00, cost: 62.00, weightOz: 80, sku: "RIV-5LB" },
    ],
  },
  {
    name: "Elion Blend",
    category: "Blend",
    description: "Our approachable house blend — Huila and Tolima in a 60/40 split. Balanced caramel, walnut, and mild citrus. Works beautifully as both drip and espresso.",
    weightOz: 12,
    cost: 11.00,
    price: 18.00,
    active: true,
    photoUrl: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=600&h=600&fit=crop&q=80",
    variants: [
      { name: "12 oz", price: 18.00, cost: 11.00, weightOz: 12, sku: "BLD-12" },
      { name: "5 lb", price: 62.00, cost: 38.00, weightOz: 80, sku: "BLD-5LB" },
      { name: "12-pack (12 oz)", price: 198.00, cost: 125.00, weightOz: 144, sku: "BLD-12PK" },
    ],
  },
  {
    name: "Ethiopia Guji",
    description: "Wild blueberry, jasmine, and dark chocolate from Hambela Wamena in the Guji zone. Natural process. A seasonal release that regulars wait for.",
    weightOz: 12,
    cost: 17.00,
    price: 26.00,
    active: true,
    category: "Single Origin",
    photoUrl: "https://images.unsplash.com/photo-1541167760496-1628856ab772?w=600&h=600&fit=crop&q=80",
    variants: [
      { name: "12 oz", price: 26.00, cost: 17.00, weightOz: 12, sku: "GUJ-12" },
      { name: "5 lb", price: 89.00, cost: 58.00, weightOz: 80, sku: "GUJ-5LB" },
    ],
  },
];

// Wholesale customers — seeded alongside products on demo reset
export const DEMO_WHOLESALE_CUSTOMERS = [
  { name: "Mika Nakamura", company: "Bluewave Café", email: "mika@bluewavecafe.com", phone: "(415) 555-0101", address: { address1: "2340 Fillmore St", city: "San Francisco", province: "CA", zip: "94115" }, netTerms: 30, paymentMethod: "net_terms", notes: "Weekly standing order. Prefers morning delivery." },
  { name: "Arturo Vasquez", company: "Roasted SF", email: "arturo@roastedsf.com", phone: "(415) 555-0112", address: { address1: "518 Haight St", city: "San Francisco", province: "CA", zip: "94117" }, netTerms: 30, paymentMethod: "net_terms", notes: "" },
  { name: "Priya Srinivasan", company: "Corporate Brews · Meta HQ", email: "priya@corporatebrews.co", phone: "(650) 555-0145", address: { address1: "1 Hacker Way", city: "Menlo Park", province: "CA", zip: "94025" }, netTerms: 30, paymentMethod: "ach", notes: "Large quarterly orders. Net-30 ACH." },
  { name: "Diego Romero", company: "Twin Peaks Roasting", email: "diego@twinpeaksroasting.com", phone: "(510) 555-0133", address: { address1: "1200 Market St", city: "Oakland", province: "CA", zip: "94607" }, netTerms: 15, paymentMethod: "net_terms", notes: "" },
  { name: "Sasha Lindqvist", company: "East Bay Beans", email: "sasha@eastbaybeans.com", phone: "(510) 555-0158", address: { address1: "4000 Shattuck Ave", city: "Berkeley", province: "CA", zip: "94703" }, netTerms: 30, paymentMethod: "net_terms", notes: "Bi-weekly order cadence." },
  { name: "Nathan O'Brien", company: "Harborview Hotel Group", email: "nathan@harborviewhotel.com", phone: "(415) 555-0177", address: { address1: "55 Fourth St", city: "San Francisco", province: "CA", zip: "94103" }, netTerms: 30, paymentMethod: "ach", notes: "Hotel F&B account. Send invoice to accounts@harborviewhotel.com." },
  { name: "Camille Laurent", company: "Gourmet Pantry", email: "camille@gourmetpantry.com", phone: "(510) 555-0192", address: { address1: "2100 Broadway", city: "Oakland", province: "CA", zip: "94612" }, netTerms: 30, paymentMethod: "net_terms", notes: "Second reminder sent — payment 22 days overdue." },
  { name: "Elise Bergstrom", company: "Fernwood Bistro", email: "elise@fernwoodbistro.com", phone: "(510) 555-0204", address: { address1: "888 Piedmont Ave", city: "Oakland", province: "CA", zip: "94611" }, netTerms: 30, paymentMethod: "net_terms", notes: "" },
  { name: "Anaya Krishnamurthy", company: "Summit Innovation", email: "anaya@summitinnovation.io", phone: "(415) 555-0216", address: { address1: "550 California St", city: "San Francisco", province: "CA", zip: "94104" }, netTerms: 30, paymentMethod: "net_terms", notes: "Corporate office coffee program." },
];

/* ─── Demo Billing ─────────────────────────────────────────────────────
   Synthetic invoices and POs for demo mode. Covers 6 months of activity
   with realistic statuses (paid, overdue, draft, sent). */

const billNow = Date.now();
const billMsDay = 86400000;
const daysAgo = (n) => new Date(billNow - n * billMsDay).toISOString().slice(0, 10);
const daysFromNow = (n) => new Date(billNow + n * billMsDay).toISOString().slice(0, 10);

export const DEMO_BILLING_SETTINGS = {
  companyName: "Elion Roaster",
  address: "2314 Cesar Chavez St, San Francisco, CA 94110",
  email: "billing@elionroaster.com",
  phone: "(415) 555-0182",
  website: "elionroaster.com",
  paymentTermsDays: 30,
  paymentInstructions: "ACH preferred. Routing 121000248 · Account 4010234567. Checks payable to Elion Roaster LLC.",
  scheduleEnabled: true,
  scheduleFrequency: "weekly",
  scheduleDay: "monday",
};

export const DEMO_INVOICES = [
  /* ── Paid (historical) ── */
  {
    id: "inv_demo_01", number: "INV-1001",
    clientName: "Bluewave Café", clientEmail: "mika@bluewavecafe.com",
    clientAddress: "2340 Fillmore St, San Francisco, CA 94115",
    lineItems: [
      { id: "li_01a", description: "Ethiopia Yirgacheffe — 5 lb bags × 12", qty: 12, unitPrice: 89.00 },
      { id: "li_01b", description: "Elion Blend — 5 lb bags × 8", qty: 8, unitPrice: 62.00 },
    ],
    subtotal: 1564.00, taxAmt: 0, total: 1564.00, taxPct: 0,
    invoiceDate: daysAgo(142), dueDate: daysAgo(112),
    status: "paid", sentAt: now - 142 * MS_DAY, paidAt: now - 118 * MS_DAY, paidDate: daysAgo(118),
    notes: "Monthly standing order. Net-30.", createdAt: now - 142 * MS_DAY,
  },
  {
    id: "inv_demo_02", number: "INV-1002",
    clientName: "Corporate Brews · Meta HQ", clientEmail: "priya@corporatebrews.co",
    clientAddress: "1 Hacker Way, Menlo Park, CA 94025",
    lineItems: [
      { id: "li_02a", description: "Ethiopia Yirgacheffe — 5 lb bags × 20", qty: 20, unitPrice: 89.00 },
      { id: "li_02b", description: "Colombia Huila — 5 lb bags × 15", qty: 15, unitPrice: 95.00 },
      { id: "li_02c", description: "Elion Blend — 12-pack × 10", qty: 10, unitPrice: 198.00 },
    ],
    subtotal: 5705.00, taxAmt: 0, total: 5705.00, taxPct: 0,
    invoiceDate: daysAgo(118), dueDate: daysAgo(88),
    status: "paid", sentAt: now - 118 * MS_DAY, paidAt: now - 91 * MS_DAY, paidDate: daysAgo(91),
    notes: "Quarterly office supply order.", createdAt: now - 118 * MS_DAY,
  },
  {
    id: "inv_demo_03", number: "INV-1003",
    clientName: "Roasted SF", clientEmail: "arturo@roastedsf.com",
    clientAddress: "518 Haight St, San Francisco, CA 94117",
    lineItems: [
      { id: "li_03a", description: "Rwanda Nyamasheke — 5 lb bags × 6", qty: 6, unitPrice: 92.00 },
      { id: "li_03b", description: "Ethiopia Guji — 5 lb bags × 4", qty: 4, unitPrice: 89.00 },
    ],
    subtotal: 908.00, taxAmt: 0, total: 908.00, taxPct: 0,
    invoiceDate: daysAgo(96), dueDate: daysAgo(66),
    status: "paid", sentAt: now - 96 * MS_DAY, paidAt: now - 70 * MS_DAY, paidDate: daysAgo(70),
    notes: "", createdAt: now - 96 * MS_DAY,
  },
  {
    id: "inv_demo_04", number: "INV-1004",
    clientName: "Harborview Hotel Group", clientEmail: "nathan@harborviewhotel.com",
    clientAddress: "55 Fourth St, San Francisco, CA 94103",
    lineItems: [
      { id: "li_04a", description: "Elion Blend — 5 lb bags × 24", qty: 24, unitPrice: 62.00 },
      { id: "li_04b", description: "Ethiopia Yirgacheffe — 5 lb bags × 8", qty: 8, unitPrice: 89.00 },
    ],
    subtotal: 2200.00, taxAmt: 0, total: 2200.00, taxPct: 0,
    invoiceDate: daysAgo(81), dueDate: daysAgo(51),
    status: "paid", sentAt: now - 81 * MS_DAY, paidAt: now - 55 * MS_DAY, paidDate: daysAgo(55),
    notes: "Hotel F&B standing order.", createdAt: now - 81 * MS_DAY,
  },
  {
    id: "inv_demo_05", number: "INV-1005",
    clientName: "Bluewave Café", clientEmail: "mika@bluewavecafe.com",
    clientAddress: "2340 Fillmore St, San Francisco, CA 94115",
    lineItems: [
      { id: "li_05a", description: "Colombia Huila — 5 lb bags × 10", qty: 10, unitPrice: 95.00 },
      { id: "li_05b", description: "Elion Blend — 5 lb bags × 6", qty: 6, unitPrice: 62.00 },
    ],
    subtotal: 1322.00, taxAmt: 0, total: 1322.00, taxPct: 0,
    invoiceDate: daysAgo(72), dueDate: daysAgo(42),
    status: "paid", sentAt: now - 72 * MS_DAY, paidAt: now - 45 * MS_DAY, paidDate: daysAgo(45),
    notes: "", createdAt: now - 72 * MS_DAY,
  },
  /* ── Sent (recent, awaiting payment) ── */
  {
    id: "inv_demo_06", number: "INV-1006",
    clientName: "Twin Peaks Roasting", clientEmail: "diego@twinpeaksroasting.com",
    clientAddress: "1200 Market St, Oakland, CA 94607",
    lineItems: [
      { id: "li_06a", description: "Ethiopia Guji — 5 lb bags × 8", qty: 8, unitPrice: 89.00 },
      { id: "li_06b", description: "Rwanda Nyamasheke — 5 lb bags × 6", qty: 6, unitPrice: 92.00 },
    ],
    subtotal: 1264.00, taxAmt: 0, total: 1264.00, taxPct: 0,
    invoiceDate: daysAgo(38), dueDate: daysAgo(8),
    status: "overdue", sentAt: now - 38 * MS_DAY, paidAt: null,
    notes: "", createdAt: now - 38 * MS_DAY,
  },
  {
    id: "inv_demo_07", number: "INV-1007",
    clientName: "East Bay Beans", clientEmail: "sasha@eastbaybeans.com",
    clientAddress: "4000 Shattuck Ave, Berkeley, CA 94703",
    lineItems: [
      { id: "li_07a", description: "Elion Blend — 12-pack × 5", qty: 5, unitPrice: 198.00 },
      { id: "li_07b", description: "Colombia Huila — 5 lb bags × 4", qty: 4, unitPrice: 95.00 },
    ],
    subtotal: 1370.00, taxAmt: 0, total: 1370.00, taxPct: 0,
    invoiceDate: daysAgo(28), dueDate: daysFromNow(2),
    status: "sent", sentAt: now - 28 * MS_DAY, paidAt: null,
    notes: "Net-30 terms.", createdAt: now - 28 * MS_DAY,
  },
  {
    id: "inv_demo_08", number: "INV-1008",
    clientName: "Corporate Brews · Meta HQ", clientEmail: "priya@corporatebrews.co",
    clientAddress: "1 Hacker Way, Menlo Park, CA 94025",
    lineItems: [
      { id: "li_08a", description: "Ethiopia Yirgacheffe — 5 lb bags × 24", qty: 24, unitPrice: 89.00 },
      { id: "li_08b", description: "Ethiopia Guji — 5 lb bags × 10", qty: 10, unitPrice: 89.00 },
      { id: "li_08c", description: "Elion Blend — 12-pack × 8", qty: 8, unitPrice: 198.00 },
    ],
    subtotal: 5470.00, taxAmt: 0, total: 5470.00, taxPct: 0,
    invoiceDate: daysAgo(22), dueDate: daysFromNow(8),
    status: "sent", sentAt: now - 22 * MS_DAY, paidAt: null,
    notes: "Q2 office supply restock.", createdAt: now - 22 * MS_DAY,
  },
  {
    id: "inv_demo_09", number: "INV-1009",
    clientName: "Fernwood Bistro", clientEmail: "elise@fernwoodbistro.com",
    clientAddress: "888 Piedmont Ave, Oakland, CA 94611",
    lineItems: [
      { id: "li_09a", description: "Colombia Huila — 5 lb bags × 8", qty: 8, unitPrice: 95.00 },
      { id: "li_09b", description: "Ethiopia Yirgacheffe — 5 lb bags × 4", qty: 4, unitPrice: 89.00 },
    ],
    subtotal: 1116.00, taxAmt: 0, total: 1116.00, taxPct: 0,
    invoiceDate: daysAgo(14), dueDate: daysFromNow(16),
    status: "sent", sentAt: now - 14 * MS_DAY, paidAt: null,
    notes: "", createdAt: now - 14 * MS_DAY,
  },
  /* ── Overdue ── */
  {
    id: "inv_demo_10", number: "INV-1010",
    clientName: "Gourmet Pantry", clientEmail: "camille@gourmetpantry.com",
    clientAddress: "2100 Broadway, Oakland, CA 94612",
    lineItems: [
      { id: "li_10a", description: "Finca La Riviera — 5 lb bags × 10", qty: 10, unitPrice: 95.00 },
      { id: "li_10b", description: "Ethiopia Guji — 5 lb bags × 6", qty: 6, unitPrice: 89.00 },
    ],
    subtotal: 1484.00, taxAmt: 0, total: 1484.00, taxPct: 0,
    invoiceDate: daysAgo(52), dueDate: daysAgo(22),
    status: "overdue", sentAt: now - 52 * MS_DAY, paidAt: null,
    notes: "Second request. Originally sent " + daysAgo(52) + ".",
    createdAt: now - 52 * MS_DAY,
  },
  /* ── Draft ── */
  {
    id: "inv_demo_11", number: "INV-1011",
    clientName: "Summit Innovation", clientEmail: "anaya@summitinnovation.io",
    clientAddress: "550 California St, San Francisco, CA 94104",
    lineItems: [
      { id: "li_11a", description: "Elion Blend — 12-pack × 6", qty: 6, unitPrice: 198.00 },
      { id: "li_11b", description: "Colombia Huila — 5 lb bags × 5", qty: 5, unitPrice: 95.00 },
    ],
    subtotal: 1663.00, taxAmt: 0, total: 1663.00, taxPct: 0,
    invoiceDate: daysAgo(3), dueDate: daysFromNow(27),
    status: "draft", sentAt: null, paidAt: null,
    notes: "Draft — pending delivery confirmation.", createdAt: now - 3 * MS_DAY,
  },
];

export const DEMO_POS = [
  {
    id: "po_demo_01", number: "PO-0001",
    supplierName: "Mercanta Coffee Hunters", supplierEmail: "orders@mercanta.com",
    lotId: "lot_demo_01", lotName: "La Esperanza",
    lineItems: [
      { id: "pli_01a", description: "Huila Colombia Washed Caturra — 69kg bags × 20", qty: 20, unitPrice: 4.25 * 152.12 },
    ],
    subtotal: +(20 * 4.25 * 152.12).toFixed(2), total: +(20 * 4.25 * 152.12).toFixed(2),
    poDate: daysAgo(160), expectedDate: daysAgo(130),
    status: "received", receivedAt: daysAgo(128),
    notes: "FOB Buenaventura. Includes $240 freight.", createdAt: now - 160 * MS_DAY,
  },
  {
    id: "po_demo_02", number: "PO-0002",
    supplierName: "InterAmerican Coffee", supplierEmail: "green@interamericancoffee.com",
    lotId: "lot_demo_02", lotName: "Kochere Lot 14",
    lineItems: [
      { id: "pli_02a", description: "Ethiopia Kochere Natural G1 — 60kg bags × 15", qty: 15, unitPrice: 5.10 * 132.28 },
    ],
    subtotal: +(15 * 5.10 * 132.28).toFixed(2), total: +(15 * 5.10 * 132.28).toFixed(2),
    poDate: daysAgo(110), expectedDate: daysAgo(75),
    status: "received", receivedAt: daysAgo(72),
    notes: "", createdAt: now - 110 * MS_DAY,
  },
  {
    id: "po_demo_03", number: "PO-0003",
    supplierName: "Mercanta Coffee Hunters", supplierEmail: "orders@mercanta.com",
    lotId: "lot_demo_03", lotName: "Kabuye Hill",
    lineItems: [
      { id: "pli_03a", description: "Rwanda Kabuye Bourbon Fully Washed — 60kg bags × 12", qty: 12, unitPrice: 4.75 * 132.28 },
    ],
    subtotal: +(12 * 4.75 * 132.28).toFixed(2), total: +(12 * 4.75 * 132.28).toFixed(2),
    poDate: daysAgo(78), expectedDate: daysAgo(45),
    status: "received", receivedAt: daysAgo(43),
    notes: "Milled and graded in Kigali.", createdAt: now - 78 * MS_DAY,
  },
  {
    id: "po_demo_04", number: "PO-0004",
    supplierName: "Royal Coffee NY", supplierEmail: "purchasing@royalcoffeeny.com",
    lotId: null, lotName: "",
    lineItems: [
      { id: "pli_04a", description: "Colombia Nariño Excelso EP — 70kg bags × 18", qty: 18, unitPrice: 3.95 * 154.32 },
    ],
    subtotal: +(18 * 3.95 * 154.32).toFixed(2), total: +(18 * 3.95 * 154.32).toFixed(2),
    poDate: daysAgo(35), expectedDate: daysFromNow(15),
    status: "confirmed",
    notes: "ETA per carrier: ~2 weeks. Fumigation cert attached.", createdAt: now - 35 * MS_DAY,
  },
  {
    id: "po_demo_05", number: "PO-0005",
    supplierName: "Olam Specialty Coffee", supplierEmail: "specialty@olamgroup.com",
    lotId: null, lotName: "",
    lineItems: [
      { id: "pli_05a", description: "Kenya Kirinyaga AA — 60kg bags × 10", qty: 10, unitPrice: 6.20 * 132.28 },
      { id: "pli_05b", description: "Ethiopia Guji G1 — 60kg bags × 8", qty: 8, unitPrice: 5.40 * 132.28 },
    ],
    subtotal: +(10 * 6.20 * 132.28 + 8 * 5.40 * 132.28).toFixed(2),
    total: +(10 * 6.20 * 132.28 + 8 * 5.40 * 132.28).toFixed(2),
    poDate: daysAgo(10), expectedDate: daysFromNow(45),
    status: "draft",
    notes: "Awaiting Q3 allocation confirmation from Olam.", createdAt: now - 10 * MS_DAY,
  },
];
